import { DownloadAllAttachmentsRequest, getFetcher } from "shared/api/api";
import client from "shared/api/axios";
import { getDownloadAllClaimAttachmentsRequestURI } from "shared/api/claims/api";
import { getDownloadAllIssueAttachmentsRequestURI } from "shared/api/issues/api";
import { createURL } from "shared/api/utils";
import { getDownloadAllVehicleAttachmentsRequestURI } from "shared/api/vehicles/api";
import { EventTypeEnum, ResourceTypeEnum } from "shared/types";
import { getAPIUrl } from "shared/utils/api-utils";
import { defaultHeaders, getAuthHeaders } from "shared/utils/auth-utils";

export const getAttachment = async ({
  url,
  contentType,
}: {
  url: string;
  contentType: string;
}) => {
  const apiUrl = getAPIUrl("api");

  const res = await fetch(apiUrl + url, {
    headers: {
      ...defaultHeaders,
      ...getAuthHeaders(),
      Accept: contentType,
      "Content-Type": contentType,
    },
  });

  return await res.blob();
};

const getDownloadAllAttachmentsURI = ({
  resource,
  id,
}: DownloadAllAttachmentsRequest): string => {
  switch (resource) {
    case EventTypeEnum.CLAIM:
      return getDownloadAllClaimAttachmentsRequestURI(id);
    case EventTypeEnum.ISSUE:
      return getDownloadAllIssueAttachmentsRequestURI(id);
    case ResourceTypeEnum.VEHICLE:
      return getDownloadAllVehicleAttachmentsRequestURI(id);
    default:
      throw new Error("Unsupported attachment type");
  }
};

export const getDownloadAllAttachments = (
  args: DownloadAllAttachmentsRequest
) =>
  getFetcher<Blob>(getDownloadAllAttachmentsURI(args), {
    responseType: "blob",
  });

export interface AttachmentEntityAssociationRequest {
  entityType: string;
  entityID: string;
  slot?: string;
}

export interface CreateAttachmentRequest {
  storageKey: string;
  filename: string;
  contentType: string;
  attachedTo: AttachmentEntityAssociationRequest[];
}

export const batchCreateAttachments = (
  data: CreateAttachmentRequest[],
  timeout?: number
) =>
  client.post(createURL(["attachments", "batchCreate"]), { data }, { timeout });
